// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2SGMZ","title":"ClientCherryInfo_title__37pmZ","itemText":"ClientCherryInfo_itemText__30KCJ"};